import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-daily-notification',
  templateUrl: './help-add-daily-notification.component.html',
  styleUrls: ['./help-add-daily-notification.component.scss']
})
export class HelpAddDailyNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
